import React from 'react';
import './aim-button-spotlight.styles.scss';

const AimButtonSpotlight = ({ className, children, ...props }) => {
  return (
    <button
      className={`aim-button-spotlight relative p-[1px] rounded-full group ${className || ''} fs-p`}
      {...props}
    >
      <span
        className={`bg-transparent text-white rounded-full w-full h-full flex items-center justify-center duration-300 py-1.5 px-8 gap-1`}
      >
        {children}
      </span>
    </button>
  );
};

export default AimButtonSpotlight;
